import type { JSONContent } from '@tiptap/core';

const WORDS_PER_MINUTE = 200;

export function extractText(node: JSONContent): string {
  let text = node.text ?? '';
  if (node.content) {
    for (const child of node.content) {
      text += ' ' + extractText(child);
    }
  }
  return text;
}

/** Estimates reading time in whole minutes (min 1) from Tiptap JSON content. */
export function estimateReadingTime(contentJson: JSONContent): number {
  const text = extractText(contentJson);
  const wordCount = text.trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(wordCount / WORDS_PER_MINUTE));
}
